import { render, staticRenderFns } from "./salesclerkList.vue?vue&type=template&id=0a20e3e5&scoped=true&"
import script from "./salesclerkList.vue?vue&type=script&lang=js&"
export * from "./salesclerkList.vue?vue&type=script&lang=js&"
import style0 from "./salesclerkList.vue?vue&type=style&index=0&id=0a20e3e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20e3e5",
  null
  
)

export default component.exports